"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconString = exports.transformPlacesToPoint = exports.loadNearybyType = exports.renderCenter = exports.fitBounds = exports.renderPoints = exports.neighbourhoodSagas = void 0;
var effects_1 = require("redux-saga/effects");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var googlemapStyle_1 = require("@/pages/common/states/googlemapStyle");
var NeighbourhoodInfo_1 = require("@/pages/place/states/NeighbourhoodInfo");
var PlaceAction_1 = require("@/pages/place/actions/PlaceAction");
var redux_saga_1 = require("redux-saga");
var initNeighbourhoodMap = function (id) {
    var latLng = {
        lat: 22.2815469,
        lng: 114.1570389,
    };
    var elm = document.getElementById(id);
    if (!elm)
        return;
    var map = new google.maps.Map(elm, {
        center: latLng,
        zoom: 17,
        styles: googlemapStyle_1.mapStyles,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: true,
        rotateControl: false,
        fullscreenControl: true,
        clickableIcons: false,
        gestureHandling: 'cooperative',
    });
    return map;
};
var loadNearybyType = function (type, latLng, radius) {
    return new Promise(function (resolve) {
        var typeString = NeighbourhoodInfo_1.NeighbourhoodItemType[type].toLowerCase();
        if (!window.placeService) {
            window.placeService = new google.maps.places.PlacesService(document.createElement('div'));
        }
        var placeService = window.placeService;
        placeService.nearbySearch({
            location: latLng,
            radius: "" + radius,
            type: typeString,
        }, function (nearbys) {
            resolve(nearbys);
        });
    });
};
exports.loadNearybyType = loadNearybyType;
var transformPlacesToPoint = function (nearbys, type) {
    return new Promise(function (resolve) {
        var points = nearbys.map(function (it) {
            return {
                type: type,
                name: it.name,
                lat: it.geometry.location.lat(),
                lng: it.geometry.location.lng(),
                address: it.vicinity,
                placeId: it.place_id,
                photo: it.photos ? it.photos[0].getUrl({ maxHeight: 200 }) : '',
            };
        });
        resolve(points);
    });
};
exports.transformPlacesToPoint = transformPlacesToPoint;
var getInfoWindow = function (point, info, mode) {
    var img = point.photo ?
        "<div class=\"c-neighbourhood__infoimg\"><img src=\"" + point.photo + "\" /></div>" : '';
    var addressHtml = point.address ? "\n      <div class=\"c-neighbourhood__infoaddress\">" + point.address + "</div>\n    "
        : '';
    var icon = mode === google.maps.TravelMode.DRIVING ? 'fa-car' : 'fa-walking';
    var infoWindow = new google.maps.InfoWindow({
        pixelOffset: new google.maps.Size(0, -40),
        content: "\n      <div class=\"c-neighbourhood__info\">\n        " + img + "\n        <div class=\"c-neighbourhood__infobody\">\n          <div class=\"c-neighbourhood__infoname\">" + point.name + "</div>\n          " + addressHtml + "\n          <div class=\"c-neighbourhood__infodistance\">\n            <span class=\"fas " + icon + "\" />\n            " + info.distance.text + "\n            (" + info.duration.text + ")\n          </div>\n        </div>\n      </div>\n    ",
    });
    google.maps.event.addListener(infoWindow, 'closeclick', function () {
        window.directionRenderer.setMap(null);
    });
    return infoWindow;
};
var getIconString = function (type) {
    switch (type) {
        case NeighbourhoodInfo_1.NeighbourhoodItemType.ATM:
            return 'atm';
        case NeighbourhoodInfo_1.NeighbourhoodItemType.BUS_STATION:
            return 'bus';
        case NeighbourhoodInfo_1.NeighbourhoodItemType.SUBWAY_STATION:
            return 'subway';
        case NeighbourhoodInfo_1.NeighbourhoodItemType.CAFE:
            return 'restaurant';
        case NeighbourhoodInfo_1.NeighbourhoodItemType.CONVENIENCE_STORE:
            return 'store';
        case NeighbourhoodInfo_1.NeighbourhoodItemType.PHARMACY:
            return 'pharmacy';
        case NeighbourhoodInfo_1.NeighbourhoodItemType.ATM:
            return 'atm';
        case NeighbourhoodInfo_1.NeighbourhoodItemType.SCHOOL:
            return 'school';
        case NeighbourhoodInfo_1.NeighbourhoodItemType.SCHOOL:
            return 'school';
        case NeighbourhoodInfo_1.NeighbourhoodItemType.PIN:
            return 'pin';
    }
    return 'atm';
};
exports.getIconString = getIconString;
var fitBounds = function (points, center, id) {
    var map = window.maps[id];
    var allPoints = points.map(function (it) { return new google.maps.LatLng(it.lat, it.lng, true); });
    allPoints.push(new google.maps.LatLng(center.lat, center.lng, true));
    var bounds = new google.maps.LatLngBounds();
    allPoints.map(function (it) { return bounds.extend(it); });
    map.fitBounds(bounds);
};
exports.fitBounds = fitBounds;
var renderPoints = function (points, center, id) {
    if (!window.pins) {
        window.pins = [];
        window.infoWindows = [];
        window.directionRenderer = new google.maps.DirectionsRenderer({
            preserveViewport: true,
            suppressMarkers: true,
        });
    }
    else {
        window.pins.map(function (it) { return it.setMap(null); });
        window.pins = [];
        window.infoWindows.map(function (it) { return it.close(); });
        window.infoWindows = [];
        window.directionRenderer.setMap(null);
    }
    var map = window.maps[id];
    for (var i = 0; i < points.length; i = i + 1) {
        var pin = createPin(points[i], center, map);
        window.pins.push(pin);
    }
};
exports.renderPoints = renderPoints;
var getRoute = function (a, b, option) {
    return new Promise(function (resolve) {
        var directionsService = new google.maps.DirectionsService;
        directionsService.route({
            origin: a,
            destination: b,
            travelMode: option,
        }, function (response, status) {
            if (status === 'OK') {
                return resolve(response);
            }
            return resolve(null);
        });
    });
};
var computeTotalDistanceDuration = function (result) {
    var myroute = result.routes[0];
    return {
        distance: myroute.legs[0].distance,
        duration: myroute.legs[0].duration,
    };
};
var setRoute = function (a, b) {
    return getRoute(a, b, google.maps.TravelMode.WALKING)
        .then(function (walkInfo) {
        return getRoute(a, b, google.maps.TravelMode.DRIVING).then(function (driveInfo) { return ({
            walk: walkInfo,
            drive: driveInfo,
        }); });
    })
        .then(function (infos) {
        var walk = google.maps.TravelMode.WALKING;
        var drive = google.maps.TravelMode.DRIVING;
        if (infos.walk && !infos.drive) {
            return { mode: walk, direction: infos.walk };
        }
        if (!infos.walk && infos.drive) {
            return { mode: drive, direction: infos.drive };
        }
        if (!infos.walk && !infos.drive)
            return null;
        var info = computeTotalDistanceDuration(infos.walk);
        if (info.distance.value > 1000) {
            return { mode: drive, direction: infos.drive };
        }
        return { mode: walk, direction: infos.walk };
    });
};
var drawRoute = function (info, point, pin, map) {
    window.directionRenderer.setDirections(info.direction);
    window.directionRenderer.setMap(map);
    var distanceDuration = computeTotalDistanceDuration(info.direction);
    var infoWindow = getInfoWindow(point, distanceDuration, info.mode);
    infoWindow.open(map, pin);
    window.infoWindows.push(infoWindow);
};
var createPin = function (point, center, map) {
    var icon = getIconString(point.type);
    var latLng = new google.maps.LatLng(point.lat, point.lng);
    var pin = new FaMarker(map, latLng, icon, point.name, true);
    var clickListener = function () {
        window.directionRenderer.setMap(null);
        window.infoWindows.map(function (it) { return it.close(); });
        setRoute(center, { lat: point.lat, lng: point.lng })
            .then(function (info) {
            drawRoute(info, point, pin, map);
        })
            .catch(function () {
            window.dispatchEvent(new CustomEvent('customMessage', { detail: 'noRoute' }));
        });
    };
    pin.addListener('click', clickListener);
    pin.setMap(map);
    return pin;
};
var renderCenter = function (center, radius, id) {
    if (window.centerPin) {
        window.centerPin = null;
    }
    var map = window.maps[id];
    map.setCenter(center);
    var newPin = new google.maps.Marker({
        map: map,
        icon: 'https://maps.gstatic.com/mapfiles/markers2/icon_green.png',
        position: center,
    });
    window.centerPin = newPin;
    var circle = new google.maps.Circle({
        center: center,
        radius: radius / 2,
    });
    map.fitBounds(circle.getBounds());
};
exports.renderCenter = renderCenter;
var initNeighbourhoodMapOnLoaded = function () {
    var map;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_GOOGLE_MAP_READY)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(initNeighbourhoodMap, 'neighbourhood-map')];
            case 2:
                map = _a.sent();
                if (!map)
                    return [2 /*return*/];
                window.maps['neighbourhood-map'] = map;
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setNearbyType(NeighbourhoodInfo_1.NeighbourhoodItemType.SCHOOL))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var globalMessageListener = function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, redux_saga_1.eventChannel(function (emit) {
                var listener = function (event) {
                    emit(event.detail);
                };
                window.addEventListener('customMessage', listener);
                return function () {
                    window.removeEventListener('customMessage', listener);
                };
            })];
    });
};
var watchGlobalMessage = function () {
    var channel, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(globalMessageListener)];
            case 1:
                channel = _a.sent();
                _a.label = 2;
            case 2:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(channel)];
            case 3:
                message = _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized(message))];
            case 4:
                _a.sent();
                return [3 /*break*/, 2];
            case 5: return [2 /*return*/];
        }
    });
};
var watchOnSubitemClick = function () {
    var _loop_1, state_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_1 = function () {
                    var payload, i, point, pin, map, centerPinPosition, itemPosition;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_ON_SUBITEM_CLICK)];
                            case 1:
                                payload = (_a.sent()).payload;
                                if (!window.centerPin ||
                                    !window.pins ||
                                    !window.pins.length) {
                                    return [2 /*return*/, { value: void 0 }];
                                }
                                i = payload.index;
                                point = payload.point;
                                pin = window.pins[i];
                                map = window.maps['neighbourhood-map'];
                                window.directionRenderer.setMap(null);
                                window.infoWindows.map(function (it) { return it.close(); });
                                centerPinPosition = window.centerPin.getPosition();
                                itemPosition = window.pins[i].getPosition();
                                setRoute({ lat: centerPinPosition.lat(), lng: centerPinPosition.lng() }, { lat: itemPosition.lat(), lng: itemPosition.lng() }).then(function (info) {
                                    drawRoute(info, point, pin, map);
                                });
                                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setNeighbourMobileFilter(false))];
                            case 2:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                state_1 = _a.sent();
                if (typeof state_1 === "object")
                    return [2 /*return*/, state_1.value];
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var neighbourhoodSagas = {
    watchGlobalMessage: watchGlobalMessage,
    initNeighbourhoodMapOnLoaded: initNeighbourhoodMapOnLoaded,
    watchOnSubitemClick: watchOnSubitemClick,
};
exports.neighbourhoodSagas = neighbourhoodSagas;
